//plugin for nubmer input with arrows up/down
"use strict";

$.widget("fotobook.floatNumberInput", $.fotobook.numberInput, {
    currentValue: function(){
        return parseFloat(this.element.val()) || 0;
    },
    _increment : function(step, delay){
        var widget = this,
            value = this.currentValue();

        this.element.val(this.validateValue(parseFloat((value + step).toFixed(2))));
        this._changeEnqueue();

        this.timeout = setTimeout(function(){
            delay = Math.max(delay - widget.options.timeStep, widget.options.timeMin);
            widget._increment(step, delay);
        }, delay);
    },
});
